import { RouteObject } from "react-router-dom";
import Landing from "./components/landing";
export interface HistoryRoute extends Omit<RouteObject, "children"> {
  auth?: boolean;
  children?: HistoryRoute[];
}
export const bxHistoryRoutes: HistoryRoute[] = [
  {
    path: "bx/history",
    element: <Landing />,
  },
];
